const app = {

  namespaced: true,

  state: {
    needsRefresh: false
  },

  mutations: {
    needsRefresh: (state) => state.needsRefresh = true,
    refreshed: (state) => state.needsRefresh = false
  }
}

export default app
